<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">空投设置</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create-task @onSuccess="refreshList"></create-task>
      </div>
      <el-table :data="taskList">
        <el-table-column label="ID" prop="id"></el-table-column>
        <el-table-column label="余额变更类型" prop="__type"></el-table-column>
        <el-table-column label="空投账号ID" prop="airdropUserId"></el-table-column>
        <el-table-column label="转出余额类型" prop="__fromType"></el-table-column>
        <el-table-column label="转入余额类型" prop="__toType"></el-table-column>
        <el-table-column label="是否发送通知" prop="isSendNotice">
          <template slot-scope="scope">
            {{ scope.row.isSendNotice ? '是' : '否' }}
          </template>
        </el-table-column>
        <el-table-column label="通知内容" prop="noticeContent"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.__status.color">
              {{ scope.row.__status.text }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | moment }}</span>
          </template>
        </el-table-column>
        <el-table-column width="140" label="操作">
          <template slot-scope="scope">
            <el-button
              size="small"
              circle
              icon="el-icon-tickets"
              @click="handleCheck(scope.row)"
            ></el-button>
            <el-button
              v-if="scope.row.status === 0"
              type="success"
              icon="el-icon-upload"
              circle
              size="small"
              @click="handleExecute(scope.row)"
            ></el-button>
            <el-button
              v-if="scope.row.status === 0"
              type="danger"
              icon="el-icon-delete"
              circle
              size="small"
              @click="handleRemove(scope.row)"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :size="pagination.size"
        :page="pagination.page"
        :total="totalCount"
        @pageChanged="handlePageChanged"
      >
      </pagination>
    </el-card>
    <record />
  </div>
</template>
<script>
import './store';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import CreateTask from './components/CreateTask';
import Record from './components/Record';
import Pagination from 'components/pagination';

export default {
  name: 'Airdrop',
  components: {
    CreateTask,
    Record,
    Pagination
  },
  data() {
    return {
      googleCode:''
    };
  },
  methods: {
    ...mapActions('airdrop', [
      'list',
      'execute',
      'remove',
      'billTask',
      'listAllCoin','templateDownload'
    ]),
    ...mapMutations('airdrop', ['setCheckTask', 'setRecordDialogVisible']),
    handlePageChanged(pagination) {
      this.list({
        ...pagination
      });
    },
    refreshList() {
      this.list({
        ...this.pagination
      });
    },
    handleExecute(task) {
      // this.$confirm('确定执行该任务吗？', '提示', {
      //   type: 'warning'
      // })
      //   .then(() => {
      //     this.execute(task.id).then(() => {
      //       this.$message.success('执行成功！');
      //       this.refreshList();
      //     });
      //   })
      //   .catch(() => {});
      this.$prompt('请输入谷歌验证码','提示',{
        inputPlaceholder: '谷歌验证码',
        // inputValue: this.googleCode,
      })
      .then((res) => {
        console.log('res',res);
          this.execute({id:task.id,googleCode:res.value}).then(() => {
            this.$message.success('执行成功！');
            this.refreshList();
          });
        })
        .catch(() => {});
    },
    handleRemove(task) {
      this.$confirm('确定删除该任务吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.remove(task.id).then(() => {
            this.$message.success('删除成功！');
            this.refreshList();
          });
        })
        .catch(() => {});
    },
    handleCheck(task) {
      console.log('check',task);
      this.setCheckTask(task);
      this.setRecordDialogVisible(true);
    },
    handleBill(task) {
      this.billTask(task.id).then(() => {
        this.$$message.success('操作成功！');
      });
    }
  },
  computed: {
    ...mapState('airdrop', ['pagination', 'totalCount']),
    ...mapGetters('airdrop', ['taskList'])
  },
  mounted() {
    this.list({
      ...this.pagination
    });
    this.listAllCoin()
    
  }
};
</script>
<style lang="less" scoped></style>
